//LOGO
export const LOGO = '/assets/images/logo.png'

export const BRAND_LOGO = '/assets/images/logo.png'

//SITE NAME
export const SITE_NAME = 'Zipperbuy'

// SIDE PANEL LIST
export const SIDE_PANEL = [
    {
        label: 'Home',
        path: '/dashboard',
        type: 'single',
    },
    {
        label: 'Inventory',
        type: 'multiple',
        path: 'listing',
        subLinks: [
            {
                label: 'Active',
                path: '/listing/open',
                showCount: true,
                count_name: 'activeCount',
            },
            {
                label: 'Sold',
                path: '/listing/sold',
                showCount: true,
                count_name: 'soldCount',
            },
            {
                label: 'Unsold',
                path: '/listing/unsold',
                showCount: true,
                count_name: 'unsoldCount',
            },
            {
                label: 'Draft Data',
                path: '/listing/draft',
                showCount: true,
                count_name: 'draftCount',
            },
            {
                label: 'Relisted',
                path: '/listing/relisted',
            },
            {
                label: 'New Draft',
                path: '/listing/draft/open',
            },
        ],
    },
    {
        label: 'ERP',
        path: '/erp',
        type: 'multiple',
        subLinks: [
            // {
            //     label: 'ERP',
            //     path: '/erp',
            // },
            {
                label: 'Inventory',
                path: '/erp/inventory',
            },
            {
                label: 'Manifest',
                path: '/erp/manifest',
            },
        ],
    },
    {
        label: 'Member & Item Lookup',
        path: '/member',
        type: 'single',
    },
    // {
    //     label: 'Return',
    //     path: 'return',
    //     type: 'multiple',
    //     subLinks: [
    //         {
    //             label: 'Member & Item LookUp',
    //             path: '/return/member/lookup',
    //         },
    // {
    //     label: 'Return Requested',
    //     path: '/return/requested',
    // },
    // {
    //     label: 'Completed',
    //     path: '/return/completed',
    // },
    // {
    //     label: 'Return Cancelled',
    //     path: '/return/cancelled',
    // },
    //     ],
    // },
    // {
    //     label: 'ERP',
    //     path: '/erp',
    //     type: 'pseudoMultiple',
    //     subLinks: [
    //         {
    //             label: 'Draft Auctions ',
    //             path: '/erp/auction/draft',
    //         },
    //         {
    //             label: 'Active Auctions',
    //             path: '/erp/auction/open',
    //         },
    //         {
    //             label: 'Closed Auctions',
    //             path: '/erp/auction/closed',
    //         },
    //         {
    //             label: 'All Auctions',
    //             path: '/erp/auction/all',
    //         },
    //     ],
    // },

    // {
    //     label: 'Schedule Pickup',
    //     path: '/schedulepickup',
    //     type: 'single',
    // },

    {
        label: 'Invoice',
        path: 'invoice',
        type: 'multiple',
        subLinks: [
            {
                label: 'All',
                path: '/invoice/all',
            },
            {
                label: 'Unpaid',
                path: '/invoice/unpaid',
            },
            {
                label: 'Paid',
                path: '/invoice/paid',
            },
            // {
            //     label: 'Partial',
            //     path: '/invoice/draft',
            // },
            {
                label: 'Cancel',
                path: '/invoice/cancel',
            },
        ],
    },
    {
        label: 'Customers',
        path: 'buyers',
        type: 'multiple',
        subLinks: [
            {
                label: 'All ',
                path: '/buyers/all',
            },
            {
                label: 'Active',
                path: '/buyers/active',
            },
            // {
            //     label: 'Unverified',
            //     path: '/buyers/unverified',
            // },
            {
                label: 'Deactivated',
                path: '/buyers/deactivate',
            },
            // {
            //     label: 'Rejected',
            //     path: '/buyers/suspended',
            // },
        ],
    },
    {
        label: 'Seller',
        path: 'org',
        type: 'multiple',
        subLinks: [
            {
                label: 'All ',
                path: '/org/all',
            },
            {
                label: 'Active',
                path: '/org/active',
            },
            {
                label: 'Deactivate',
                path: '/org/deactivate',
            },
            // {
            //     label: 'Rejected',
            //     path: '/org/suspended',
            // },
        ],
    },
    {
        label: 'Locations',
        path: '/locations',
        type: 'single',
    },
    {
        label: 'Seller Payout',
        path: 'seller_payout',
        type: 'multiple',
        subLinks: [
            // {
            //     label: 'Transaction',
            //     path: '/seller_payout/transaction',
            //     type: 'single',
            // },
            {
                label: 'Manual Transfer',
                path: '/seller_payout/manual',
                type: 'single',
            },
            {
                label: 'Auto Transfer',
                path: '/seller_payout/auto',
                type: 'single',
            },
        ],
    },

    {
        label: 'Zipperbuy Payout',
        path: 'zb',
        type: 'multiple',
        subLinks: [
            // {
            //     label: 'Zipperbuy Transaction',
            //     path: '/zb/zp_transaction',
            //     type: 'single',
            // },
            {
                label: 'Zipperbuy Transfer',
                path: '/zb/zp/transfer',
                type: 'single',
            },
        ],
    },
    {
        label: 'Agencies',
        path: '/agency',
        type: 'multiple',
        subLinks: [
            {
                label: 'All Agencies',
                path: '/agency/all',
            },
            {
                label: 'Agency Users',
                path: '/agency/users/all',
                // dynamicPaths: true,
            },
            {
                label: '',
                path: '/agency/users/edit',
                subType: 'User Edit',
                dynamicPaths: true,
            },
            {
                label: 'Payment Received',
                path: '/agency/payment',
            },
            {
                label: '',
                path: '/agency/new',
                subType: 'Add',
                dynamicPaths: true,
            },
            {
                label: '',
                path: '/agency/edit',
                subType: 'Edit',
                dynamicPaths: true,
            },
        ],
    },
    {
        label: 'Coupons List',
        path: '/registration_coupon',
        type: 'single',
    },
    {
        label: 'Gift Cards List',
        path: '/gift_card',
        type: 'single',
    },
    {
        label: 'Report',
        path: '/report',
        type: 'single',
    },
    // {
    //     label: 'Analytics',
    //     path: 'report',
    //     type: 'multiple',
    //     subLinks: [
    //         {
    //             label: 'Report',
    //             path: '/report',
    //             type: 'single',
    //         },
    //     ],
    // },
    // {
    //     label: 'Marketing',
    //     path: 'campaign',
    //     type: 'multiple',
    //     subLinks: [
    //         {
    //             label: 'Create Campaign ',
    //             path: '/campaign/create',
    //         },
    //         {
    //             label: 'Email template',
    //             path: '/campaign/template',
    //         },
    //     ],
    // },
    {
        label: 'Communications',
        path: 'communications',
        type: 'multiple',
        subLinks: [
            {
                label: 'Email Template',
                path: '/communications/email',
            },
            {
                label: 'SMS Template',
                path: '/communications/sms',
            },
            {
                label: 'Email Logs',
                path: '/communications/logs/emailLogs',
            },
            {
                label: 'SMS Logs',
                path: '/communications/logs/smsLogs',
            },
        ],
    },
    // {
    //     label: 'Online Store',
    //     path: 'store',
    //     type: 'multiple',
    //     subLinks: [
    //         {
    //             label: 'Themes',
    //             path: '/store/themes',
    //         },
    //         {
    //             label: 'Store Configuration',
    //             path: '/store/configuration',
    //         },
    //     ],
    // },
    {
        label: 'Plugins',
        path: '/plugins',
        type: 'single',
    },
    {
        label: 'Settings',
        path: 'settings',
        type: 'multiple',
        subLinks: [
            {
                label: 'Static Pages',
                path: '/settings/static',
            },
            {
                label: 'Banner Image',
                path: '/settings/banner',
            },
            {
                label: 'Pallet Pricing',
                path: '/settings/palletPricing',
            },
            {
                label: 'Category',
                path: '/settings/category',
            },
            {
                label: 'Condition',
                path: '/settings/condition',
            },
            {
                label: 'Location',
                path: '/settings/location',
            },
            {
                label: 'General Settings',
                path: '/settings/general',
            },
            {
                label: 'Header Menus',
                path: '/settings/headermenus',
            },
            {
                label: 'Maintanence',
                path: '/settings/maintanence',
            },

            {
                label: 'Offer Increments',
                path: '/settings/bid_increments',
            },
            // {
            //     label: 'Tax Code',
            //     path: '/settings/tax_table',
            // },

            {
                label: 'UI Settings',
                path: '/ui_settings',
            },
            {
                label: 'Language Manager',
                path: '/languageManager',
            },
            {
                label: 'Subscribers',
                path: '/subscribers',
            },
            {
                label: 'Profile',
                path: '/profile',
            },
            {
                label: 'Change Password',
                path: '/change_password',
            },
            {
                label: 'Two Factor Authentication',
                path: '/settings/twoFactor',
            },
        ],
    },

    {
        label: 'Employee',
        path: '/employees',
        type: 'single',
        // subLinks: [
        //     {
        //         label: 'All',
        //         path: '/employees/all',
        //     },
        // ],
    },
    {
        label: 'Sync Intenvory',
        path: '/syncinventory',
        type: 'single',
    },

    // {
    //     label: 'My Billing Info',
    //     path: 'billing',
    //     type: 'multiple',
    //     subLinks: [
    //         {
    //             label: 'Payment',
    //             path: '/billing/all/0',
    //         },
    //         {
    //             label: 'Paid Invoice',
    //             path: '/billing/paid',
    //         },
    //         {
    //             label: 'Unpaid Invoice',
    //             path: '/billing/unpaid',
    //         },
    //     ],
    // },

    {
        label: 'Template',
        type: 'multiple',
        path: 'templates',
        subLinks: [
            {
                label: 'Listing',
                path: '/templates/listing',
            },
            // {
            //     label: 'Auction',
            //     path: '/templates/auction',
            // },
        ],
    },
    {
        label: 'Transactions',
        path: 'transaction',
        type: 'multiple',
        subLinks: [
            {
                label: 'Payment',
                path: '/transaction/payment',
            },
        ],
    },

    // {
    //     label: 'Order Control',
    //     path: 'ordercontrol',
    //     type: 'multiple',
    //     subLinks: [
    //         {
    //             label: 'New',
    //             path: '/ordercontrol/new',
    //         },
    //         // {
    //         //     label: 'In Transit',
    //         //     path: '/ordercontrol/intransit',
    //         // },
    //         {
    //             label: 'Ready for Pickup',
    //             path: '/ordercontrol/pickup',
    //         },
    //         {
    //             label: 'Completed Order',
    //             path: '/ordercontrol/completed',
    //         },
    //         {
    //             label: 'Cancelled',
    //             path: '/ordercontrol/cancelled',
    //         },
    //         // {
    //         //     label: 'Pending',
    //         //     path: '/ordercontrol/undelivered',
    //         // },
    //         // {
    //         //     label: 'Delivered',
    //         //     path: '/ordercontrol/delivered',
    //         // },
    //     ],
    // },

    // {
    //     label: 'Inventory',
    //     path: 'inventory',
    //     type: 'multiple',
    //     subLinks: [
    //         {
    //             label: 'Add Inventory',
    //             path: '/inventory/add',
    //         },
    //         {
    //             label: 'Active Inventory',
    //             path: '/inventory/active',
    //         },
    //     ],
    // },
    // {
    //     label: 'Logs',
    //     path: 'logs',
    //     type: 'multiple',
    //     subLinks: [
    //         {
    //             label: 'Email',
    //             path: '/logs/emailLogs',
    //         },
    //         {
    //             label: 'SMS',
    //             path: '/logs/smsLogs',
    //         },
    //     ],
    // },
    {
        label: 'Questions & Answers',
        path: '/questions_answers',
        type: 'single',
        showCount: true,
        count_name: 'noReplyCount',
    },
    {
        label: 'Seller On Boarding',
        path: '/onboarding',
        type: 'single',
    },
    {
        label: 'Messages',
        path: '/messages',
        type: 'single',
    },

    {
        label: 'Dynamic Pages',
        path: 'dynamic',
        type: 'multiple',
        subLinks: [
            {
                label: 'Dynamic Fields',
                path: '/dynamic/pages',
                type: 'single',
            },
            {
                label: 'Dynamic Tables',
                path: '/dynamic/table/pages',
                type: 'single',
            },
        ],
    },
]

export const ALL_PAGINATION = [
    {
        value: '20',
        show: '20 Results per page',
    },
    {
        value: '40',
        show: '40 Results per page',
    },
    {
        value: '60',
        show: '60 Results per page',
    },
]

export const HEADER_SIDE_PANEL = []
